import React from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../../cra/src/styling/breakpointsMinWidth';

const FooterSection = styled.footer`
  margin: 28px;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 12px;

  @media ${breakpointsMinWidth.tabletSm} {
    margin: 28px 0;

    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 24px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-template-columns: repeat(12, 1fr);
  }
`;

const Wrap = styled.div`
  text-align: right;

  grid-column: 1/-1;

  padding: 16px 0 0 0;

  border-top: 1px solid #e0e0e0;

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 2/-2;
  }

  @media ${breakpointsMinWidth.desktopLg} {
    grid-column: 3/-3;
  }
`;

const FocusedText = styled.span`
  color: #333d47;

  font-weight: 500;
`;

const Footer = ({ blogs }) => (
  <FooterSection>
    <Wrap>
      Showing <FocusedText>{blogs.length}</FocusedText> out of{' '}
      <FocusedText>{blogs.length}</FocusedText> articles...
    </Wrap>
  </FooterSection>
);

export default Footer;
